import type { ContentFormat } from './schemas/content.js';

/**
 * Engine 0.5.0+: a reel is of one type. The engine and the database keep two
 * axes — format (reel | carousel) and type (scenes | diagram | listicle); a
 * carousel is always «Сцены». «Подборка» (listicle) came with engine 0.7.0.
 */
export const REEL_TYPES = ['scenes', 'diagram', 'listicle'] as const;
export type ReelType = (typeof REEL_TYPES)[number];

/** What a person picks on an idea card: one «вид» instead of the two axes. */
export const PUBLICATION_KINDS = ['reel_scenes', 'reel_diagram', 'reel_listicle', 'carousel'] as const;
export type PublicationKind = (typeof PUBLICATION_KINDS)[number];

const REEL_KIND: Record<ReelType, PublicationKind> = {
  scenes: 'reel_scenes',
  diagram: 'reel_diagram',
  listicle: 'reel_listicle',
};

export function kindOf(format: ContentFormat, type: ReelType): PublicationKind {
  if (format === 'carousel') {
    if (type !== 'scenes') throw new Error(`a carousel has no type ${type}`);
    return 'carousel';
  }
  return REEL_KIND[type];
}

export function fromKind(kind: PublicationKind): { format: ContentFormat; type: ReelType } {
  switch (kind) {
    case 'reel_scenes':
      return { format: 'reel', type: 'scenes' };
    case 'reel_diagram':
      return { format: 'reel', type: 'diagram' };
    case 'reel_listicle':
      return { format: 'reel', type: 'listicle' };
    case 'carousel':
      return { format: 'carousel', type: 'scenes' };
  }
}
